module.exports = __webpack_public_path__ + "img/1-zh.9a7cf068.jpg";